export const GET_RESPONSE_ERROR = "GET_RESPONSE_ERROR"
export const GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS"
export const CREATE_TRANSATION = "CREATE_TRANSATION"
export const CREATE_INVOICE = "CREATE_INVOICE"
export const GET_ALL_REVENUE = "GET_ALL_REVENUE"
export const CUSTOM_ERROR = "CUSTOM_ERROR"
export const GET_PARTICULAR_REVENUE = "GET_PARTICULAR_REVENUE"